"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.titleCase = void 0;
var replacer = function (matchedText) { return matchedText.charAt(0).toUpperCase() + matchedText.substr(1).toLowerCase(); };
var titleCase = function (str) {
    return str.replace(/\w\S*/g, replacer);
};
exports.titleCase = titleCase;
//# sourceMappingURL=titleCase.js.map